export const regionData = [
  {
    id: 1,
    name: "Gauteng",
    amount: 12,
  },
  {
    id: 2,
    name: "North West",
    amount: 12,
  },
  {
    id: 2,
    name: "Mpumalanga",
    amount: 12,
  },
  {
    id: 2,
    name: "Limpopo",
    amount: 12,
  },
  {
    id: 2,
    name: "Free State",
    amount: 12,
  },
];
